import React, { useState, useMemo } from 'react';
import { Modal, Tree, Typography } from 'antd';
import type { DataNode } from 'antd/es/tree';
import { FolderOutlined, HomeOutlined } from '@ant-design/icons';
import type { FolderTreeNode } from '../models';

const { Text } = Typography;

interface MoveToFolderModalProps {
  open: boolean;
  title?: string;
  tree: FolderTreeNode[];
  currentFolderID?: string | null;
  onOk: (targetFolderID: string | null) => void;
  onCancel: () => void;
}

const MoveToFolderModal: React.FC<MoveToFolderModalProps> = ({
  open,
  title = '移動到資料夾',
  tree,
  currentFolderID,
  onOk,
  onCancel,
}) => {
  const [selectedKey, setSelectedKey] = useState<string | null>(null);

  const toTreeData = (nodes: FolderTreeNode[]): DataNode[] =>
    nodes.map((node) => ({
      key: node.id,
      title: node.name,
      icon: <FolderOutlined />,
      children: node.children?.length ? toTreeData(node.children) : undefined,
      disabled: node.id === currentFolderID,
    }));

  const treeData: DataNode[] = [
    {
      key: '__root__',
      title: <Text>根目錄（未分類）</Text>,
      icon: <HomeOutlined />,
      children: toTreeData(tree),
    },
  ];

  const handleSelect = (keys: React.Key[]) => {
    if (keys.length > 0) {
      const key = keys[0] as string;
      setSelectedKey(key === '__root__' ? null : key);
    }
  };

  const handleOk = () => {
    onOk(selectedKey);
    setSelectedKey(null);
  };

  const handleCancel = () => {
    setSelectedKey(null);
    onCancel();
  };

  return (
    <Modal
      title={title}
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="移動"
      cancelText="取消"
      width={400}
    >
      <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
        選擇目標資料夾：
      </Text>
      <div style={{ maxHeight: 400, overflow: 'auto', border: '1px solid #f0f0f0', borderRadius: 6, padding: 8 }}>
        <Tree
          showIcon
          showLine={{ showLeafIcon: false }}
          defaultExpandAll
          selectedKeys={selectedKey !== null ? [selectedKey] : ['__root__']}
          treeData={treeData}
          onSelect={handleSelect}
          blockNode
        />
      </div>
    </Modal>
  );
};

export default MoveToFolderModal;
